import React from 'react';
import { Panel, ButtonToolbar, Button, OverlayTrigger, Popover, Modal } from 'react-bootstrap';
import { Link } from 'react-router';
import Dropzone from 'react-dropzone';

const spinner = (
  <div className="text-center">
    <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
    <span className="sr-only">Loading...</span>
  </div>
);

const popover = (
  <Popover id="routing-help-popover" title="Routing Import Help">
    <div>
      <strong style={{fontSize: '12px'}}>Date:</strong><br/>
      <ul style={{fontSize: '12px', listStyle: 'disc', listStylePosition: 'inside'}}>
        <li>Date is required, cannot be blank</li>
        <li>Needs to be in format Month Day, Year(Ex. Oct 1, 17)</li>
      </ul>
      <strong style={{fontSize: '12px'}}>Location:</strong><br/>
      <ul style={{fontSize: '12px', listStyle: 'disc', listStylePosition: 'inside'}}>
        <li>Must have location for each date</li>
        <li>Location needs to be City, State or City, Country</li>
      </ul>
      <strong style={{fontSize: '12px'}}>Venue:</strong><br/>
      <ul style={{fontSize: '12px', listStyle: 'disc', listStylePosition: 'inside'}}>
        <li>Only need venue on days with day type - Show</li>
      </ul>
      <strong style={{fontSize: '12px'}}>Day Type:</strong><br/>
      <ul style={{fontSize: '12px', listStyle: 'disc', listStylePosition: 'inside'}}>
        <li>Can only be 1 of 4 types - Show, Prep, travel, Off</li>
        <li>Choose from Dropdown menu</li>
      </ul>
    </div>
  </Popover>
);

function seconds2Days(seconds) {
  const days = Number.parseInt(seconds, 10) / 86400;
  return `${days} days`;
}
class RoutingWidget extends React.Component {
  render() {
    let routing;
    let overlayt
    const {tour_stops} = this.props.tour
    if (this.props.tour.tour_stops.length > 0) {
      const duration = seconds2Days(this.props.tour.duration);
      const state = this.props.tour.state === 'DR' && !this.props.readOnly;     
      
      routing = (
        <div>
          <p>{this.props.tour.shows} shows.</p>
          <p>{this.props.tour.cities} cities.</p>
          <p>{duration}.</p>
          <p>{this.props.tour.groups.length} Groups.</p>  
          {state && (
            <p>
              <Button bsStyle="info" onClick={this.props.onOpen}>
                <i className="fa fa-trash" /> Clear Route
              </Button>
            </p>
          )}
          {this.props.showModel &&(
            <Modal bsSize="large" show={this.props.showModel} onHide={()=>this.props.onClose()}>
                <Modal.Header closeButton>
                    <Modal.Title>Clear Route</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>This will erase your routing and all hotel bids from the program.  Are you sure you want to delete routing?</p><br/>
                    <ButtonToolbar style={{ float: 'right' }}>
                      <Button bsStyle="success" onClick={this.props.onClose}>Cancel</Button>&nbsp;&nbsp;
                      <Button bsStyle="success" onClick={this.props.clearRoute}>Confirm</Button>
                    </ButtonToolbar>
                </Modal.Body><br/>
                <Modal.Footer >
                    <p></p>
                </Modal.Footer>
            </Modal>
          )}
        </div>
      );
      overlayt = (<div></div>);
    } else {
      let text;
      if (this.props.isProcessing) {
        text = spinner;
      } else {
        text = (
          <div className="text-center">
            Drop your route spreadsheet here, or click to select files to upload.
            <br />
            <i className="fa fa-file-excel-o fa-5x" aria-hidden="true" />
          </div>
        );
      }
      routing = (
        <div>
          <Dropzone
            className="overview-tab-panel-dropzone"
            ref={node => {
              this.dropzone = node;
            }}
            onDrop={this.props.onDrop}
          >
            <div>{text}</div>
          </Dropzone>
          <Link to="/Example_Tour-Routing.xlsx" target="_blank">
            Download Template
          </Link>
        </div>
      );
      overlayt = (
        <div>
          <OverlayTrigger rootClose="true" trigger="click" placement="right" delay={{ show: 250, hide: 400 }} overlay={popover}>
              <i className="fa fa-info-circle " aria-hidden="true" style={{float: 'right', margin: '5px', cursor: 'pointer',fontSize:'20px'}}/>
            </OverlayTrigger>
        </div>          
      );
    }
    return (
      <div className="col-sm-3">
        <div style={{border:'1px solid rgb(235 224 224)',height:'49vh'}}>
          <div className='header' style={{border:'1px solid rgb(235 224 224)',backgroundColor:'green',display:'flex',justifyContent:"space-between",padding:tour_stops.length>0?"10px":"7px"}} >
            <div style={{fontSize:'16px'}}>
              <span>Routing</span>
            </div>
              <div>
                {overlayt}
              </div>
          </div>
          <div style={{padding:'5px'}}>
            {routing}
          </div>
        </div>
        {/* <Panel header="Routing">{routing}</Panel> */}
      </div>
    );
  }
}
export default RoutingWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/RoutingWidget.js